import React, { useState, useEffect } from "react";
import {
    Button, Card, CardBody, Col, Container, Form, FormGroup, Input, InputGroup, Label, Row, FormFeedback,
    Modal,
    ModalHeader,
    ModalBody,
} from "reactstrap";
import Select from "react-select";
import Breadcrumb from "components/Common/Breadcrumb";
import withRouter from "components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addNewBook, getSerts, updateBook } from "helpers/fakebackend_helper";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";


const Book = () => {
    //meta title
    // document.title = "Create Book"

    const router = useNavigate();
    const { state } = useLocation();
    const [Classlist, setClassList] = useState([])
    const [Sublist, setSubList] = useState([])
    const [Medlist, setMedList] = useState([])
    const [Termlist, setTermList] = useState([])
    const [isLoading, setisLoading] = useState(false)
    const [modal, setModal] = useState(false);
    const [Pre, setPre] = useState();
    const [iPre, setiPre] = useState();
    const [text, setText] = useState("");
    const [book, setBook] = useState(null)


    const toggle = () => {
        setModal(!modal);
    };



    useEffect(() => {
        if (!modal) {
            setiPre()
        }
    }, [modal])


    const getClassList = () => {
        getSerts().then((res) => {
            setClassList(res)
        }).catch((err) => {
            console.log('err', err)
        })
    }

    const getList = (id) => {
        getSerts(id).then((res) => {
            setSubList(res)
        }).catch((err) => {
            console.log('err', err)
        })
    }

    const getList2 = (id) => {
        getSerts(id).then((res) => {
            setMedList(res)
        }).catch((err) => {
            console.log('err', err)
        })
    }

    useEffect(() => {
        if (state?.data) {
            setBook(state?.data)
            setText(state?.data?.tamil_title)
            getList(state?.data?.class_name?.id)
            getList2(state?.data?.subject_name?.id)
            setPre(state?.data?.book_path)
        }
    }, [state])

    console.log('bookbook', book);

    const getList3 = (id) => {
        getSerts(id).then((res) => {
            setTermList(res)
        }).catch((err) => {
            console.log('err', err)
        })
    }

    useEffect(() => {
        getClassList();
    }, [])

    const bookFormik = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            class_id: book?.class_name?.id ?? '',
            subject_id: book?.subject_name?.id ?? '',
            medium_id: book?.medium_name?.id ?? '',
            term_id: '',
            title: book?.eng_title ?? '',
            sub_title: book?.tamil_title ?? '',
            book_image: '',
            book: book?.book_path ?? '',
            textbook: book?.epub_path ?? '',
            order_by: book?.order ?? ''
        },
        validationSchema: Yup.object().shape({
            class_id: Yup.string().required("Select class"),
            subject_id: Yup.string().required("Select subject"),
            medium_id: Yup.string().required("Select medium"),
            // term_id: Yup.string().required("Select term_id"),
            title: Yup.string().required("Enter English Title"),
            // sub_title: Yup.string().required("Enter Tamil Title"),
            // book_image: Yup.string().required("upload HTML File"),
            book: Yup.string().required("Upload Book PDF"),
            // textbook: Yup.string().required("Upload epub File"),
            order_by: Yup.string().required("Enter Order By"),
        }),
        onSubmit: (values) => {
            let formData = new FormData();
            formData.append("class_id", values.class_id);
            formData.append("subject_id", values.subject_id);
            formData.append("medium_id", values.medium_id);
            // formData.append("term_id", values.term_id);
            formData.append("eng_title", values.title);
            formData.append("tamil_title", text);
            formData.append("book_path", values.book);
            formData.append("html_path", values.book_image);
            formData.append("epub_path", values.textbook);
            formData.append("order_by", values.order_by);
            if (book != null) {
                formData.append("scert_book_id ", book.scert_book_id);
                setisLoading(true)
                updateBook(formData).then(res => {
                    setisLoading(false)
                    if (res?.success) {
                        toast.success("Update Success")
                        router(-1)
                    } else {
                        toast.error(res?.message ?? 'somthing went wrong!')
                    }
                }).catch(err => {
                    setisLoading(false)
                    toast.error(err.message)
                })
            } else {
                setisLoading(true)
                addNewBook(formData).then(res => {
                    setisLoading(false)
                    if (res?.success) {
                        toast.success("Added Success")
                        router(-1)
                    } else {
                        toast.error(res?.message ?? 'somthing went wrong!')
                    }
                }).catch(err => {
                    setisLoading(false)
                    toast.error(err.message)
                })
            }
        }
    });



    return (<>
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumb title="BOOK" breadcrumbItem="SCERT BOOK" />
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <h4 className="card-title mb-3">{book != null ? "Update Book" : 'Create Book'}</h4>
                                <form onSubmit={bookFormik.handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">English Title<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="title"
                                                    placeholder="English Title"
                                                    type="text"
                                                    onChange={bookFormik.handleChange}
                                                    onBlur={bookFormik.handleBlur}
                                                    value={bookFormik.values.title || ""}
                                                    invalid={
                                                        bookFormik.touched.title && bookFormik.errors.title ? true : false
                                                    }
                                                />

                                                {bookFormik.touched.title && bookFormik.errors.title ? (
                                                    <FormFeedback type="invalid">{bookFormik.errors.title}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Tamil Title<span className="text-danger">*</span></Label>
                                                {/* <Input
                                                    name="sub_title"
                                                    placeholder="Tamil Title"
                                                    type="text"
                                                    onChange={bookFormik.handleChange}
                                                    onBlur={bookFormik.handleBlur}
                                                    value={bookFormik.values.sub_title || ""}
                                                    invalid={
                                                        bookFormik.touched.sub_title && bookFormik.errors.sub_title ? true : false
                                                    }
                                                /> */}
                                                <ReactTransliterate
                                                    value={text}
                                                    onChangeText={setText}
                                                    lang="ta" // Tamil Language
                                                    name="sub_title"
                                                    placeholder="Tamil Title"
                                                    style={{
                                                        width: "100%",
                                                        padding: "7px",
                                                        // fontSize: "16px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                    }}
                                                />
                                                {bookFormik.touched.sub_title && bookFormik.errors.sub_title ? (
                                                    <FormFeedback type="invalid">{bookFormik.errors.sub_title}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Select Class<span className="text-danger">*</span></Label>
                                                <Select
                                                    options={Classlist}
                                                    getOptionLabel={(e) => e.name1}
                                                    getOptionValue={(e) => e.id}
                                                    name="class_id"
                                                    value={Classlist?.find(e => e?.id == bookFormik.getFieldProps('class_id').value)}
                                                    onBlur={bookFormik.handleBlur}
                                                    onChange={(e) => { getList(e?.id); bookFormik.setFieldValue('class_id', e?.id) }}
                                                    placeholder='Select Class'
                                                    className="select2-selection"
                                                />
                                                {bookFormik.touched.class_id && bookFormik.errors.class_id ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.class_id}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Select Subject<span className="text-danger">*</span></Label>
                                                <Select
                                                    options={Sublist}
                                                    getOptionLabel={(e) => e?.name1}
                                                    getOptionValue={(e) => e?.id}
                                                    value={Sublist?.find(e => e?.id == bookFormik.getFieldProps('subject_id').value)}
                                                    onChange={(e) => { getList2(e?.id); bookFormik.setFieldValue('subject_id', e?.id) }}
                                                    placeholder='Select Subject'
                                                    className="select2-selection"
                                                />
                                                {bookFormik.touched.subject_id && bookFormik.errors.subject_id ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.subject_id}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label>Select Medium<span className="text-danger">*</span></Label>
                                                <Select
                                                    placeholder="Select Medium"
                                                    options={Medlist}
                                                    getOptionLabel={(e) => e?.name1}
                                                    getOptionValue={(e) => e?.id}
                                                    value={Medlist?.find(e => e?.id == bookFormik.getFieldProps('medium_id').value)}
                                                    onChange={(e) => { getList3(e?.id); bookFormik.setFieldValue('medium_id', e?.id) }}
                                                    className="select2-selection"
                                                />
                                                {bookFormik.touched.medium_id && bookFormik.errors.medium_id ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.medium_id}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        {/* <Col md="6">
                                            <div className="mb-3">
                                                <Label>Select Term</Label>
                                                <Select
                                                    placeholder='Select Term'
                                                    options={Termlist}
                                                    getOptionLabel={(e) => e.name1}
                                                    getOptionValue={(e) => e.id}
                                                    onChange={(e) => { bookFormik.setFieldValue('term_id', e?.id) }}
                                                    className="select2-selection"
                                                />
                                                {bookFormik.touched.term_id && bookFormik.errors.term_id ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.term_id}</p>
                                                ) : null}
                                            </div>
                                        </Col> */}

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Book (PDF)<span className="text-danger">*</span></Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        name="book"
                                                        placeholder=""
                                                        type="file"
                                                        accept="application/pdf"
                                                        onChange={(e) => { bookFormik.setFieldValue("book", e.target.files[0]); }}
                                                    />
                                                    {/* <button type="button" disabled={!bookFormik.getFieldProps('book').value} onClick={() => { toggle(); setPre(bookFormik.getFieldProps('book').value?.startsWith('https') ? bookFormik.getFieldProps('book').value : URL.createObjectURL(bookFormik.getFieldProps('book').value)); }} className=" btn btn-primary rounded"><i className="mdi mdi-eye font-size-18" id="pre" /></button> */}
                                                    {
                                                        book != null ?
                                                            <button type="button" disabled={!bookFormik.getFieldProps('book').value} onClick={() => {
                                                                window.open(bookFormik.getFieldProps('book').value, '_blank')
                                                            }} className=" btn btn-primary rounded"><i className="bx bxs-download font-size-18" id="pre" /></button>
                                                            : ''
                                                    }
                                                </div>
                                                {bookFormik.touched.book && bookFormik.errors.book ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.book}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Upload HTML File (Zip)</Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        name="book_image"
                                                        placeholder=""
                                                        type="file"
                                                        accept="application/zip"
                                                        onChange={(e) => { bookFormik.setFieldValue("book_image", e.target.files[0]); }}
                                                    />
                                                    {/* <button type="button" disabled={!bookFormik.getFieldProps('book_image').value} onClick={() => { toggle(); setiPre(URL.createObjectURL(bookFormik.getFieldProps('book_image').value)); }} className=" btn btn-primary rounded"><i className="mdi mdi-eye font-size-18" id="pre" /></button> */}
                                                    {
                                                        book != null ?
                                                            <button type="button" disabled={!bookFormik.getFieldProps('book_image').value} onClick={() => {
                                                                window.open(bookFormik.getFieldProps('book_image').value, '_blank')
                                                            }} className=" btn btn-primary rounded"><i className="bx bxs-download font-size-18" id="pre" /></button>
                                                            : ''
                                                    }
                                                </div>
                                                {bookFormik.touched.book_image && bookFormik.errors.book_image ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.book_image}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Upload epub File</Label>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        name="textbook"
                                                        placeholder=""
                                                        type="file"
                                                        accept=".epub"
                                                        onChange={(e) => { bookFormik.setFieldValue("textbook", e.target.files[0]); }}
                                                    />
                                                    {/* <button type="button" disabled={!bookFormik.getFieldProps('textbook').value} onClick={() => { toggle(); setPre(URL.createObjectURL(bookFormik.getFieldProps('textbook').value)); }} className=" btn btn-primary rounded"><i className="mdi mdi-eye font-size-18" id="pre" /></button> */}
                                                    {
                                                        book != null ?
                                                            <button type="button" disabled={!bookFormik.getFieldProps('textbook').value} onClick={() => {
                                                                window.open(bookFormik.getFieldProps('textbook').value, '_blank')
                                                            }} className=" btn btn-primary rounded"><i className="bx bxs-download font-size-18" id="pre" /></button>
                                                            : ''
                                                    }
                                                </div>
                                                {bookFormik.touched.textbook && bookFormik.errors.textbook ? (
                                                    <p className="mb-0 text-danger mt-1" >{bookFormik.errors.textbook}</p>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Order By<span className="text-danger">*</span></Label>
                                                <Input
                                                    name="order_by"
                                                    placeholder="Order By"
                                                    type="text"
                                                    onChange={bookFormik.handleChange}
                                                    onBlur={bookFormik.handleBlur}
                                                    value={bookFormik.values.order_by || ""}
                                                    invalid={
                                                        bookFormik.touched.order_by && bookFormik.errors.order_by ? true : false
                                                    }
                                                />

                                                {bookFormik.touched.order_by && bookFormik.errors.order_by ? (
                                                    <FormFeedback type="invalid">{bookFormik.errors.order_by}</FormFeedback>
                                                ) : null}
                                            </div>
                                        </Col>

                                        <Col lg={12}>
                                            <div className="text-end mb-4">
                                                <Button disabled={isLoading} type="submit" color="primary">
                                                    {
                                                        isLoading ?
                                                            <>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                Loading
                                                            </>
                                                            :
                                                            book != null ? "Update Book" : "Create Book"
                                                    }
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                        Preview
                    </ModalHeader>
                    <ModalBody>
                        {
                            iPre ?
                                <img src={iPre} style={{ width: '100%', height: '350px', objectFit: 'cover' }} className="preImh" />
                                : <iframe src={Pre} className="w-100" width="100%" height="400px"></iframe>
                        }
                    </ModalBody>
                </Modal>
            </Container>
        </div>
    </>)
}


export default withRouter(Book);